<div *ngFor="let item of items; let levelIndex = index">
  <div [dir]="isRight ? 'rtl': 'auto'" class="side-content-container"
    *ngIf="selectedItem === item.text && item.children">
    <div class="d-flex">
      <kendo-button [style.transform]="isRight ? 'scaleX(-1)': null" (click)="returnToNav()" class="py-0 px-2 mt-1"
        fillMode="clear" imageUrl="assets/icons/back.svg"></kendo-button>
      <p class="text-center mt-3 px-2 content-title">{{item.text | translate}}</p>
    </div>
    <div *ngIf="item.children">
      <div *ngFor="let child of item.children; let childIndex = index;">
        <div *ngIf="child.children" class="wrapper bg-light">

          <kendo-expansionpanel [dir]="isRight ? 'rtl': 'auto'" expandIcon="k-i-arrow-chevron-down"
            collapseIcon="k-i-arrow-chevron-right" tabindex="-1"
            [expanded]="expandedPanels[selectedItem] === childIndex"
            (expandedChange)="expandedPanels[selectedItem] = $event ? childIndex : -1" [title]="child.text | translate"
            class="bg-light border-0">
            <div *ngIf="child.children" class="content bg-light">
              <div *ngIf="child.text === 'ReportManager'">
                <bi-child-report [ChildReports]="child.children"></bi-child-report>
              </div>
              <div *ngIf="child.text != 'ReportManager'">
                <div *ngFor="let grandChild of child.children; let grandChildIndex=index" class="d-grid gap-2 w-100">

                  <ng-container *ngIf="grandChild.children">
                    <kendo-expansionpanel  [dir]="isRight ? 'rtl': 'auto'" expandIcon="k-i-arrow-chevron-down"
                      collapseIcon="k-i-arrow-chevron-right" tabindex="-1"
                      [expanded]="childExpandedPanels[selectedItem] === grandChildIndex"
                      (expandedChange)="childExpandedPanels[selectedItem] = $event ? grandChildIndex : -1"
                      [title]="grandChild.text | translate" class="bg-light child-expansion border-0">
                      <div class="content bg-light">
                        <div *ngFor="let greatGrandChild of grandChild.children; index as i" class="d-grid gap-2 w-100">
                          <button [dir]="isRight ? 'rtl': 'auto'"
                            [ngClass]="{'active': activeButton === greatGrandChild.text}"
                            (click)="setActiveButton(greatGrandChild.text); navigate(greatGrandChild.path); "
                            class="btn sideBar-btn child-sideBar  py-2 text-start border-0" type="button"
                            [id]="'btn-' + greatGrandChild.text">{{greatGrandChild.text | translate}}</button>
                        </div>
                      </div>
                    </kendo-expansionpanel>

                  </ng-container>
                  <ng-container *ngIf="!grandChild.children">
                    <button [dir]="isRight ? 'rtl': 'auto'" [ngClass]="{'active': activeButton === grandChild.text}"
                      (click)="setActiveButton(grandChild.text); navigate(grandChild.path);"
                      class="btn sideBar-btn py-2 text-start border-0" type="button"
                      [id]="'btn-' + grandChild.text">{{grandChild.text | translate}}</button>
                  </ng-container>
              </div>
              </div>
             
            </div>
          </kendo-expansionpanel>
        </div>
        <div [dir]="isRight ? 'rtl': 'auto'" class="d-grid gap-2 w-100" *ngIf="!child.children">
          <button [ngClass]="{'active': activeButton === child.text}"
            (click)="setActiveButton(child.text); navigate(child.path); " class="btn sideBar-btn fw-bold my-2 text-start"
            type="button" [id]="'btn-' + child.text">{{child.text | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>